import {PoItem} from "../../entities/PoItem";

export class PoItemsFactory {

    public static makePoItem(): PoItem {
        return {
            cargoValue: null,
            cargoValueCurr: null,
            cargoValueCurrId: null,
            cbm: null,
            cntrnr: null,
            colli: null,
            colliType: null,
            colliTypeId: null,
            contactPersonEmail: null,
            createdTimestamp: null,
            createdUser: null,
            createdUserId: null,
            deleted: null,
            descr: null,
            ecrTimestamp: null,
            extId: null,
            height: null,
            hsCode: null,
            id: null,
            isParent: null,
            length: null,
            metOriginCountry: null,
            metOriginCountryId: null,
            modifiedTimestamp: null,
            modifiedUserId: null,
            oogcntr: null,
            pcs: null,
            pn1: '',
            pn2: '',
            pn3: '',
            stackable: null,
            status: null,
            subject: null,
            subjectId: null,
            tracedo: null,
            tracedoId: null,
            updatetd: null,
            weight: null,
            width: null,
            createPosIndex: null,
        }
    }

    public static makeCopy(poItem: PoItem): PoItem {
        return { ...poItem };
    }
}